import type { FormikProps } from 'formik';
import { SIGNUP_FIELDS } from '../../constants/signUp.constants';
import type { UserSignUp } from '../../interfaces/auth.interface';
import { SignupField } from './SignupField';

interface SignUpNonCoreFieldsGridProps {
  formikProps: FormikProps<UserSignUp>;
  disabled: string;
}

/**
 * Render non-core fields for sign up form.
 *
 * @param {Object} props - The props object.
 * @param {Object} props.formikProps - The formik props object.
 * @param {boolean} props.disabled - Whether the fields should be disabled or not.
 *
 * @return {Array} - An array of React components representing the non-core fields.
 */
export function SignUpNonCoreFieldsGrid(
  props: SignUpNonCoreFieldsGridProps,
): any {
  const { formikProps, disabled } = props;
  const { PHONE_NUMBER, COMPANY_NAME, JOB_TITLE, ZIP_CODE } = SIGNUP_FIELDS;

  const NOT_CORE_FIELDS = [PHONE_NUMBER, COMPANY_NAME, JOB_TITLE, ZIP_CODE];
  return NOT_CORE_FIELDS.map((field) => (
    <SignupField
      key={field}
      disabled={disabled}
      id={field}
      {...formikProps}
      placeholder={field}
      type="text"
    />
  ));
}
